import { Client } from "@/Common/Api/Client";
import { Guid } from "@/Common/Models/Guid";
import { Patient } from "@/Common/Models/Patient/Patient";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { MedicalItem } from "../Models/MedicalSummary/MedicalItem";

class MedicalItemApiClient {
    public static async setOutsideMedicalItemEncounterIds(patientModel: Patient, medicalItems: MedicalItem[], consultationContextLookupId?: string): Promise<Guid | null> {
        if (!patientStore.IsMedicalItemFromOutsideNote)
            return null;

        const encounterRequestData = {
            PatientContactFacetId: patientModel.PatientResponse.ContactFacet_id,
            SiteId: sessionStore.getCurrentEmployee().getActiveSite().getId(),
            ConsultationTypeId: sessionStore.getCurrentEmployeeDefaultSpecializationLookupId(),
            ConsultationContextLookupId: consultationContextLookupId,
            IsFromMedicalSummary: patientStore.IsMedicalItemFromOutsideNote
        };

        const response = await Client.postAsync<{ EncounterId: Guid }>(ServerOperations.Server.Myle_Patient_MedicalNote_GetOrCreateEncounterForDirectProfileEdits, encounterRequestData);

        for (const item of (medicalItems ?? []))
            item.RelatedEncounterId = response.data.EncounterId;

        return response.data.EncounterId;
    }
}

export { MedicalItemApiClient };
